import { createFileRoute } from '@tanstack/react-router';
import { BoardDetailPage } from '@/features/boards';

export const Route = createFileRoute('/workspace/$workspaceId/boards/$boardId')({
  component: BoardDetailPage,
});
